export default __webpack_public_path__ + "static/media/website.90fa5f51.svg";